import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import Button from '../buttons'
import './header-actions.scss'

const HeaderActions = ({
  showBackButton,
  primaryButton,
  primaryButtonText,
  primaryButtonIcon,
  secondaryButton,
  secondaryButtonText,
  isDisabledSecondaryButton,
  secondaryButtonIcon,
}) => {
  const { formatMessage: msg } = useIntl()
  const navigate = useNavigate()

  return (
    <div className="actions-btns">
      {
        /* Botton back */
        showBackButton && (
          <Button
            id="gobackBtn"
            btnText={msg({ id: 'button.back' })}
            btnType="button"
            btnClass="btn__transparent"
            isDisabled={false}
            onHandleClick={() => navigate(-1)}
            iconLeft
            iconSize="1.2rem"
            iconClass="pi-angle-left"
          />
        )
      }
      {/* others bottons*/}
      {primaryButton && (
        <Button
          id="primary-button"
          btnText={primaryButtonText ? msg({ id: primaryButtonText }) : ''}
          btnType="button"
          btnClass="btn__bg-dark-blue"
          isDisabled={false}
          onHandleClick={() => primaryButton()}
          iconRight
          iconSize="1rem"
          iconClass={primaryButtonIcon}
        />
      )}
      {secondaryButton && (
        <Button
          id="secondary-button"
          btnText={secondaryButtonText ? msg({ id: secondaryButtonText }) : ''}
          btnType="button"
          btnClass="btn__bg-orange"
          isDisabled={isDisabledSecondaryButton || false}
          onHandleClick={() => secondaryButton()}
          iconRight
          iconSize="1rem"
          iconClass={secondaryButtonIcon}
        />
      )}
    </div>
  )
}

export default HeaderActions
